export default __webpack_public_path__ + "static/media/aws-cloud-practicnor.1d4d9fa2.png";